/**
 * Map the active i18n language to a BCP-47 locale tag that Web Speech API
 * understands. The app language codes are intentionally short (`en`, `hi`);
 * SpeechRecognition needs the regional variant.
 *
 * Falls back to `en-US` for anything we haven't mapped.
 */
const SPEECH_LOCALES = {
    en: "en-US",
    hi: "hi-IN",
    te: "te-IN",
    ta: "ta-IN",
    ml: "ml-IN",
    kn: "kn-IN",
    fr: "fr-FR",
    es: "es-ES",
    pt: "pt-BR",
    it: "it-IT",
    de: "de-DE",
};

export function mapLocaleToBcp47(lang) {
    if (!lang) return "en-US";
    const base = String(lang).toLowerCase().split("-")[0];
    return SPEECH_LOCALES[base] || "en-US";
}
